module.exports = "<div class=\"m-kml-content\">\n   <p class=\"m-kml-name\">{{{name}}}</p>\n   <div class=\"m-kml-desc\">{{{desc}}}</div>\n</div>";